<template>
  <div class="app-root">
    <AppHeader :categories="categories" />
    <main class="main-content">
      <router-view :categories="categories" />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import { getHome } from './api'

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
  data () {
    return { categories: [] }
  },
  created () {
    this.loadCatalog()
  },
  methods: {
    async loadCatalog () {
      try {
        const data = await getHome()
        this.categories = data.categories || []
      } catch (e) {
        console.error(e)
        this.categories = []
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&family=Source+Serif+4:opsz,wght@8..60,400;8..60,600&family=Inter:wght@400;500;600&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: #f4f6fa;
  color: #1a2744;
  line-height: 1.6;
}

.app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content { flex: 1; }

.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 1rem;
  color: #4a6080;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 3px solid #dce4f0;
  border-top-color: #1a3a6b;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }
@keyframes fadeSlide {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes pulse {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}
</style>
